/**
 * Generated vector art shipped under `public/art/`. All of it is SVG, so it
 * scales to any density and is themable via the brand palette.
 *
 * Pack wrappers are *not* here — they're rendered by `components/fx/PackFoil`
 * so each pack can be tinted from its own id and split in half for the rip.
 */
export const STOREFRONT_ART = {
  /** Card backing shown before any reveal (packs, vault, raffle queue). */
  cardBack: "/art/card-back.svg",
  /** Rainbow foil wash used by `.holo-surface` and PackFoil. */
  holoSheen: "/art/holo-sheen.svg",
  /** Radial light rays behind a revealed high-rarity card. */
  burst: "/art/burst.svg",
  /** Film grain overlay for `.bg-noise`. */
  noise: "/art/noise.svg",
  /** Faint grid used by `.bg-grid`. */
  grid: "/art/grid-glow.svg",
  /** Friendly card-creature for empty states and zero-data panels. */
  mascot: "/art/mascot.svg",
  /** Raffle ticket illustration for entry and tracking panels. */
  ticket: "/art/ticket.svg",
} as const;

export type StorefrontArtKey = keyof typeof STOREFRONT_ART;
